import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ButtonPrimary from "../../elements/button/ButtonPrimary";
import {
  DocumentAddIcon,
  DocumentDownloadIcon,
} from "@heroicons/react/outline";
import { saveAs } from "file-saver";
import axiosAPI from "../../utils/axios-api";
import SMModal from "../../elements/modals/SMModal";
import { useParams } from "react-router";
import swal from 'sweetalert2';

const API = process.env.REACT_APP_API;
const IsiKuesionerFile = (props) => {
  const { idKuesioner } = useParams();
  const [namaFile, setnamaFile] = useState("");
  const [urlSoal, seturlSoal] = useState(null);

  //   jawaban
  const [dataJawaban, setdataJawaban] = useState(null);
  const [namaJawaban, setnamaJawaban] = useState(null);

  const [modalSave, setmodalSave] = useState(false);
  const [loadingSubmit, setloadingSubmit] = useState(0);
  const [kuesioner_id, setKuesionerId] = useState(0);
  const [responden_id, setRespondenId] = useState(0);

  useEffect(() => {
    // console.log(props.dataSoal);
    seturlSoal(props.dataSoal);
    setKuesionerId(props.kuesioner_id)
    setRespondenId(props.responden_id)
    // setnamaFile(props.dataSoal.substring(props.dataSoal.lastIndexOf("/") + 1, props.dataSoal.length))
  }, []);

  function download_file(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
      var save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
      save.download = fileName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search("Chrome") < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        var evt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    }

    // for IE < 11
    else if (!!window.ActiveXObject && document.execCommand) {
      var _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, fileName || fileURL);
      _window.close();
    }
  }

  function onFileChange(params) {
    let file = params.target.files[0];
    setdataJawaban(file);
    setnamaJawaban(file.name);
  }

  function renderSave(params) {
    let pesan = null;
    let buttonSubmit = null;
    if (loadingSubmit === 0) {
      pesan = <p>Submit jawaban anda?</p>;
      buttonSubmit = (
        <button
          onClick={() => konfirmasiScoin()}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Submit
        </button>
      );
    } else if (loadingSubmit === 1) {
      pesan = <p>Loading</p>;
      buttonSubmit = (
        <button className="px-4 py-2 rounded-lg bg-gray-20">Loading</button>
      );
    } else if (loadingSubmit === 2) {
      pesan = <p>Berhasil</p>;
      buttonSubmit = (
        <button
          onClick={() => {
            window.history.back();
          }}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Oke
        </button>
      );
    } else {
      pesan = <p>Gagal submit</p>;
      buttonSubmit = (
        <button
          onClick={() => save()}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Ulangi
        </button>
      );
    }

    return (
      <div className="flex flex-col px-4 py-4">
        {pesan}
        <div className="flex flex-row gap-2 my-4">
          {buttonSubmit}
          <button
            onClick={() => setmodalSave(false)}
            className="px-4 py-2 rounded-lg bg-gray-200"
          >
            Batal
          </button>
        </div>
      </div>
    );
  }

  function konfirmasiScoin(){
    let body = {kuesioner_id: idKuesioner, responden_id: responden_id}
    
      axiosAPI
        .post(API + "scoin/konfirmasi", body)
        .then((res) => {
            save(res.data.message)
        })
        .catch((xhr) => {
          console.log(xhr)
        });

  }

  function save(message) {
    let form = new FormData();

    form.append("file", dataJawaban);

    setloadingSubmit(1);
    axiosAPI
      .post(API + "kuesioner/" + idKuesioner + "/upload-jawaban", form)
      .then((res) => {
        if (res.data.status === "success") {
          swal.fire('Berhasil', message + ', ' + res.data.message, 'success');
          setloadingSubmit(2);
          window.location.replace("/partisipasi");
        } else {
          swal.fire('Gagal', message + ', ' + res.data.message, 'error');
          setloadingSubmit(2);
        }
      })
      .catch((err) => {
        setloadingSubmit(3);
      });
  }
  return (
    <div className="flex flex-col p-4">
      <SMModal
        title="Submit"
        show={modalSave}
        onClose={() => setmodalSave(!modalSave)}
      >
        {renderSave()}
      </SMModal>
      <p>Isi kuesioner file</p>

      <div className="p-4 rounded-lg mt-4 border border-gray-100 flex flex-col bg-white">
        <p>Download Soal</p>

        <div className="flex flex-row justify-between p-4 items-center bg-gray-100 rounded mt-4">
          <div className="flex row items-center">
            <DocumentDownloadIcon className="h-6 w-6" />
            <p>
              {!!urlSoal
                ? urlSoal.substring(
                    urlSoal.lastIndexOf("/") + 1,
                    urlSoal.length
                  )
                : null}
            </p>
          </div>
          {!!urlSoal ? (
            // <a href={urlSoal} target="_blank" download>
            //   <ButtonPrimary text="Download" type="solid" />
            // </a>
            <ButtonPrimary
              text="Download"
              type="solid"
              onClick={() => download_file(urlSoal)}
            />
          ) : null}
        </div>
      </div>

      <div className="p-4 rounded-lg mt-4 border border-gray-100 flex flex-col bg-white">
        <p>Upload Jawaban</p>

        <div className="flex flex-row justify-between p-4 items-center bg-gray-100 rounded mt-4">
          <div className="flex row items-center">
            <DocumentAddIcon className="h-6 w-6" />
            <p>{!!namaJawaban ? namaJawaban : "Klik tombol di samping"}</p>
          </div>
          <div>
            <input
              type="file"
              accept="application/pdf, application/vnd.ms-excel, .xlsx, .xls, .csv, .docx"
              name="file"
              id="file"
              className="none"
              style={{ display: "none" }}
              onChange={(e) => onFileChange(e)}
            />
            <label
              className="cursor-pointer px-4 py-2 rounded-lg text-sm text-blue-500 border border-blue-400"
              htmlFor="file"
              for="file"
            >
              Upload Jawaban
              {/* <ButtonPrimary text="Upload File" type="solid" /> */}
            </label>
          </div>
        </div>
      </div>

      <div className="flex my-6">
        {!!dataJawaban ? (
          <ButtonPrimary
            text="Submit"
            type="solid"
            onClick={() => setmodalSave(true)}
          />
        ) : null}
      </div>
    </div>
  );
};

IsiKuesionerFile.propTypes = {};

export default IsiKuesionerFile;
